angular.module('mercury.modules.stock.stocktaketemplate')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Stock.StocktakeTemplates', {
    url: '/stocktaketemplate',
    controller: 'StockStocktaketemplateListCtrl',
    templateUrl: 'modules/stock/stocktaketemplate/list.tpl.html'
  });

  $stateProvider.state('Stock.StocktakeTemplates.Create', {
    url: '/create',
    data: {
      dialogState: true
    },
    onEnter: ['$state', 'dialog', function($state, dialog) {
      dialog.open({
        templateUrl: 'modules/stock/stocktaketemplate/create.tpl.html',
        controller: 'StockStocktakeTemplateCreateCtrl',
        size: 'sm'
      }).catch(function() {
        $state.go('^', null, {location: 'replace'});
      });
    }],
    onExit: ['dialog', function(dialog) {
      dialog.close();
    }]
  });

  $stateProvider.state('Stock.StocktakeTemplateEdit', {
    url: '/stocktaketemplate/edit/:id',
    controller: 'StockStocktaketemplateEditCtrl',
    templateUrl: 'modules/stock/stocktaketemplate/edit.tpl.html',
    data: {
      menuLinkState: 'Stock.StocktakeTemplates'
    }
  });
}]);
